export enum SortByEnum {
  Followers = 'followers',
  PriceLowHigh = 'priceLowHigh',
  PriceHighLow = 'priceHighLow',
  Distance = 'distance',
}
